<template>
    <div class="refresh"></div>
</template>

<script>
export default {
    data() {
        return {}
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$router.replace(from.path);
        })
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// app/components/Refresh.vue